














































// Importing components
import LayoutMain from '@/layputs/LayoutMain.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import ThePreviewNavBar from '@/components/preview/ThePreviewNavBar.vue';
import ThePreviewMenu from '@/components/preview/ThePreviewMenu.vue';
import TheMapRestaurants from '@/components/restaurants/TheMapRestaurants.vue';
// Importing function
import {getRestaurantPreview} from '@/ts/restaurants/get-restaurant';
import {handleScroll} from '@/ts/other/additional';
import {getProducts} from '@/ts/products/get-products';

export default {
    name: 'PageRestaurantPreview',
    components: {
        TheMapRestaurants,
        ThePreviewMenu,
        ThePreviewNavBar,
        LayoutMain,
        BaseLoadingAnimation,
    },
    props: {},
    data() {
        return {
            restaurant: {
                working_hours: Object(),
            },
            image: Object(),
            categories: Array(),
            productVariations: Array(),
            search: String(''),
        };
    },
    mounted() {
        handleScroll();
        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setLoadingOn');
        getRestaurantPreview(this.$route.query.restaurant).then((response) => {
            this.restaurant = response;
            this.restaurant.tags = this.restaurant.tags.slice(0, 3).join(', ');
            this.image = {'background-image': 'url(' + 'https://api.foodninja.net' + this.restaurant.cover_image + ')'};
            const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const date = new Date();
            const dayName = days[date.getDay()];
            this.restaurant.working_hours = this.restaurant.working_hours.find((item) => item.day === dayName);
        });
        getProducts(this.$route.query.restaurant).then((response: any) => {
            if (response.hasOwnProperty('menu-categories')) {
                this.categories = response['menu-categories'].sort((a, b) => {
                    return (a.attributes.order > b.attributes.order) ? 1 :
                        ((b.attributes.order > a.attributes.order) ? -1 : 0);
                });

            }
        }).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
    created() {
        window.addEventListener('scroll', handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', handleScroll);
    },
};
